<template>
  <div class="forma-erp kasa-obracun">

    <div class="traka-ekrana">
      <span class="naslov">Obračun kase</span>
      <span class="broj" v-if="o && o.odBroja">Računi {{ o.odBroja }}–{{ o.doBroja }}</span>
      <span class="uz">{{ nazivFirme }} · {{ $store.state.businessYear }}</span>
      <v-spacer></v-spacer>
      <v-btn text small color="primary" class="text-none" @click="naPopis">
        <v-icon small left>mdi-format-list-bulleted</v-icon>Računi
      </v-btn>
      <v-btn text small color="primary" class="text-none" @click="naKasu">
        <v-icon small left>mdi-cash-register</v-icon>Kasa
      </v-btn>
    </div>

    <div class="pa-3">
      <v-card outlined class="mb-3">
        <v-card-text class="alatke">
          <v-text-field outlined dense hide-details label="Od" type="date"
            v-model="odDatuma" style="max-width:170px"></v-text-field>
          <v-text-field outlined dense hide-details label="Do" type="date"
            v-model="doDatuma" style="max-width:170px"></v-text-field>
          <v-btn small color="primary" class="text-none" :loading="ucitavam" @click="ucitaj">
            Prikaži
          </v-btn>
          <v-btn small outlined color="primary" class="text-none" @click="danas">Danas</v-btn>
          <v-btn small outlined color="primary" class="text-none" @click="jucer">Jučer</v-btn>
          <v-btn small outlined color="primary" class="text-none" @click="ovajMjesec">Ovaj mjesec</v-btn>
          <v-spacer></v-spacer>
          <v-btn small outlined color="primary" class="text-none" :disabled="!ima" @click="naA4">
            <v-icon small left>mdi-file-document-outline</v-icon>A4
          </v-btn>
          <v-btn small outlined color="primary" class="text-none"
            :disabled="!ima" :loading="saljem" @click="naTraku">
            <v-icon small left>mdi-printer</v-icon>Na traku
          </v-btn>
        </v-card-text>
      </v-card>

      <div v-if="greska" class="greska-traka">{{ greska }}</div>

      <div v-if="ima">
        <!-- Ono zbog cega se obracun radi ide prvo i krupno. -->
        <v-card outlined class="mb-3 ukupno-kartica">
          <v-card-text>
            <div class="ukupno">
              <div>
                <div class="oznaka">UKUPNO NAPLAĆENO</div>
                <div class="uz">
                  {{ o.ukupno.brojRacuna }} {{ mnozina(o.ukupno.brojRacuna) }} ·
                  {{ razdobljeTekst }}
                </div>
              </div>
              <b>{{ novac(o.ukupno.iznos) }}</b>
            </div>
            <div class="razrada">
              <span>Osnovica <b>{{ novac(o.ukupno.osnovica) }}</b></span>
              <span>PDV <b>{{ novac(o.ukupno.pdv) }}</b></span>
              <span v-if="o.ukupno.bezPdv">Bez PDV-a <b>{{ novac(o.ukupno.bezPdv) }}</b></span>
            </div>
          </v-card-text>
        </v-card>

        <!-- Nefiskalizirani ulaze u zbroj iznad, ali se moraju vidjeti. -->
        <div class="upozorenje mb-3" v-if="o.nefiskalizirani.brojRacuna">
          <v-icon color="orange darken-3">mdi-alert-outline</v-icon>
          <div>
            <b>{{ o.nefiskalizirani.brojRacuna }} {{ mnozina(o.nefiskalizirani.brojRacuna) }}
              bez JIR-a, {{ novac(o.nefiskalizirani.iznos) }} EUR.</b>
            <span class="uz">
              Novac je naplaćen i u zbroju je, ali ti računi još nisu prijavljeni Poreznoj.
            </span>
            <a class="uz veza" @click="naPopis">Otvori popis</a>
          </div>
        </div>

        <v-row dense>
          <v-col cols="12" md="6">
            <v-card outlined>
              <v-card-title class="naslov-kartice">Po stopama PDV-a</v-card-title>
              <table class="zbroj">
                <thead>
                  <tr><th class="l">Stopa</th><th>Osnovica</th><th>PDV</th><th>Ukupno</th></tr>
                </thead>
                <tbody>
                  <tr v-for="g in o.poStopama" :key="'s' + g.stopa">
                    <td class="l">{{ novac(g.stopa) }} %</td>
                    <td>{{ novac(g.osnovica) }}</td>
                    <td>{{ novac(g.pdv) }}</td>
                    <td class="jako">{{ novac(g.ukupno) }}</td>
                  </tr>
                  <tr class="zbrojni">
                    <td class="l">Ukupno</td>
                    <td>{{ novac(o.ukupno.osnovica) }}</td>
                    <td>{{ novac(o.ukupno.pdv) }}</td>
                    <td class="jako">{{ novac(o.ukupno.iznos) }}</td>
                  </tr>
                </tbody>
              </table>
            </v-card>
          </v-col>

          <v-col cols="12" md="6">
            <v-card outlined>
              <v-card-title class="naslov-kartice">Po načinu plaćanja</v-card-title>
              <table class="zbroj">
                <thead>
                  <tr><th class="l">Način</th><th>Računa</th><th>Iznos</th></tr>
                </thead>
                <tbody>
                  <tr v-for="p in o.poPlacanju" :key="p.kod">
                    <td class="l">{{ p.naziv }}</td>
                    <td>{{ p.brojRacuna }}</td>
                    <td class="jako">{{ novac(p.iznos) }}</td>
                  </tr>
                  <tr class="zbrojni">
                    <td class="l">Ukupno</td>
                    <td>{{ o.ukupno.brojRacuna }}</td>
                    <td class="jako">{{ novac(o.ukupno.iznos) }}</td>
                  </tr>
                </tbody>
              </table>
            </v-card>
          </v-col>
        </v-row>

        <!-- Razrada po danima ima smisla tek kad razdoblje obuhvaca vise dana. -->
        <v-card outlined class="mt-3" v-if="!o.razdoblje.jedanDan && o.poDanima.length > 1">
          <v-card-title class="naslov-kartice">Po danima</v-card-title>
          <table class="zbroj">
            <thead>
              <tr><th class="l">Datum</th><th>Računa</th><th>Osnovica</th><th>PDV</th><th>Iznos</th></tr>
            </thead>
            <tbody>
              <tr v-for="d in o.poDanima" :key="d.datum">
                <td class="l">{{ datum(d.datum) }}</td>
                <td>{{ d.brojRacuna }}</td>
                <td>{{ novac(d.osnovica) }}</td>
                <td>{{ novac(d.pdv) }}</td>
                <td class="jako">{{ novac(d.iznos) }}</td>
              </tr>
            </tbody>
          </table>
        </v-card>
      </div>

      <v-card outlined v-if="o && !ima">
        <div class="prazno">Nema računa u odabranom razdoblju.</div>
      </v-card>
    </div>

    <KasaA4Pregled ref="a4" />

    <v-snackbar v-model="poruka" :color="bojaPoruke" :timeout="5000" bottom>
      {{ tekstPoruke }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="poruka = false">Zatvori</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import KasaService from '@/services/KasaService'
import KasaA4Pregled from '@/components/Kasa/KasaA4Pregled'
import { sendToPrinter, printServiceUrl, printerName } from '@/components/Document/posPrint'
import { pdfObracunA4 } from '@/snippets/kasaA4'
import moneyFormat from '@/snippets/moneyFormat'
import dateFormat from '@/snippets/dateFormat'

// "2026-09-21" iz serverskog vremena, bez sata ovog racunala.
const danasnjiDatum = (iso) => String(iso || '').slice(0, 10)

export default {
  name: 'kasaobracun',
  components: {KasaA4Pregled},
  data () {
    return {
      o: null,
      odDatuma: '',
      doDatuma: '',
      ucitavam: false,
      saljem: false,
      greska: '',
      poruka: false,
      tekstPoruke: '',
      bojaPoruke: 'success'
    }
  },

  computed: {
    nazivFirme () { return this.$store.state.companyName || '' },
    ima () { return !!(this.o && this.o.ukupno && this.o.ukupno.brojRacuna) },
    razdobljeTekst () {
      if (!this.o) { return '' }
      const r = this.o.razdoblje
      return r.jedanDan ? this.datum(r.od) : this.datum(r.od) + ' – ' + this.datum(r.do)
    }
  },

  async mounted () {
    // Datum dolazi s posluzitelja, kao i svugdje u kasi.
    try {
      const {data} = await KasaService.pocetak({
        CompanyId: this.$store.state.companyid,
        BusinessYear: this.$store.state.businessYear,
        SKLADID: this.$store.state.warehousemarkid || 1
      })
      const d = danasnjiDatum(data && data.vrijeme ? data.vrijeme.datum : '')
      this.odDatuma = d
      this.doDatuma = d
    } catch (err) {
      this.greska = 'Ne mogu dohvatiti serversko vrijeme: ' + this.tekstGreske(err)
    }
    if (this.odDatuma) { await this.ucitaj() }
  },

  methods: {
    novac (v) { return moneyFormat(v) },
    datum (v) { return dateFormat(v) },
    mnozina (n) { return n === 1 ? 'račun' : 'računa' },

    async ucitaj () {
      if (!this.odDatuma) { return }
      if (this.doDatuma < this.odDatuma) { this.doDatuma = this.odDatuma }
      this.ucitavam = true
      this.greska = ''
      try {
        const {data} = await KasaService.obracun({
          CompanyId: this.$store.state.companyid,
          BusinessYear: this.$store.state.businessYear,
          SKLADID: this.$store.state.warehousemarkid || 1,
          odDatuma: this.odDatuma,
          doDatuma: this.doDatuma
        })
        this.o = data
      } catch (err) {
        this.greska = this.tekstGreske(err)
        this.o = null
      } finally {
        this.ucitavam = false
      }
    },

    pomakni (odMinus, doMinus) {
      const d = new Date(this.odDatuma || Date.now())
      const novi = new Date(d.getTime() - odMinus * 86400000)
      const dvo = (n) => String(n).padStart(2, '0')
      const s = `${novi.getFullYear()}-${dvo(novi.getMonth() + 1)}-${dvo(novi.getDate())}`
      return s
    },

    async danas () {
      const {data} = await KasaService.pocetak({
        CompanyId: this.$store.state.companyid,
        BusinessYear: this.$store.state.businessYear,
        SKLADID: this.$store.state.warehousemarkid || 1
      })
      this.odDatuma = danasnjiDatum(data.vrijeme.datum)
      this.doDatuma = this.odDatuma
      await this.ucitaj()
    },

    async jucer () {
      await this.danas()
      this.odDatuma = this.pomakni(1)
      this.doDatuma = this.odDatuma
      await this.ucitaj()
    },

    async ovajMjesec () {
      await this.danas()
      this.odDatuma = this.odDatuma.slice(0, 8) + '01'
      await this.ucitaj()
    },

    async naA4 () {
      if (!this.ima) { return }
      try {
        const izvor = await pdfObracunA4(this.o)
        this.$refs.a4.prikaziIzvor(izvor, 'Obračun ' + this.razdobljeTekst)
      } catch (err) {
        this.javi('A4 obračun se ne može pripremiti: ' + (err.message || err), 'red')
      }
    },

    async naTraku () {
      if (!this.ima || !this.o.ispisTraka) { return }
      this.saljem = true
      try {
        const podaci = Object.assign({}, this.o.ispisTraka)
        const pisac = printerName()
        if (pisac) { podaci.printer = pisac }
        const odgovor = await sendToPrinter(podaci)
        this.javi(
          odgovor.ok
            ? 'Obračun poslan na pisač.'
            : `Pisač nije odgovorio (${printServiceUrl()}): ` +
              (typeof odgovor.body === 'string' ? odgovor.body : JSON.stringify(odgovor.body)),
          odgovor.ok ? 'green' : 'red')
      } finally {
        this.saljem = false
      }
    },

    naPopis () { this.$router.push({name: 'kasaracuni'}) },
    naKasu () { this.$router.push({name: 'kasa'}) },

    tekstGreske (err) {
      const t = err && err.response && err.response.data ? err.response.data : null
      if (t && t.greska) { return t.greska }
      return err && err.message ? err.message : 'Nepoznata greška.'
    },

    javi (tekst, boja) {
      this.tekstPoruke = tekst
      this.bojaPoruke = boja || 'success'
      this.poruka = true
    }
  }
}
</script>

<style scoped>
.kasa-obracun { background: #eceff1; min-height: calc(100vh - 64px); }
.kasa-obracun .traka-ekrana { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; }
.kasa-obracun .alatke { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }

.kasa-obracun .ukupno-kartica { border-left: 4px solid #1976d2; }
.kasa-obracun .ukupno {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 16px;
}
.kasa-obracun .ukupno .oznaka { font-size: 13px; font-weight: 700; color: #1565c0; letter-spacing: 0.04em; }
.kasa-obracun .ukupno b {
  font-size: 34px;
  font-weight: 800;
  color: #1565c0;
  font-variant-numeric: tabular-nums;
  line-height: 1;
}
.kasa-obracun .razrada {
  display: flex;
  gap: 22px;
  flex-wrap: wrap;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #dbe2e8;
  font-size: 13px;
  color: #607d8b;
}
.kasa-obracun .razrada b { color: #263238; font-variant-numeric: tabular-nums; margin-left: 4px; }

.kasa-obracun .upozorenje {
  background: #fff8e1;
  border-left: 4px solid #f9a825;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.kasa-obracun .upozorenje b { color: #8d6e00; }
.kasa-obracun .upozorenje .uz { color: #8d6e00; margin-left: 6px; font-weight: 400; }
.kasa-obracun .upozorenje .veza { text-decoration: underline; cursor: pointer; }

.kasa-obracun table.zbroj { width: 100%; border-collapse: collapse; }
.kasa-obracun table.zbroj th {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #607d8b;
  text-align: right;
  padding: 8px 12px;
  border-bottom: 1px solid #dbe2e8;
  font-weight: 700;
}
.kasa-obracun table.zbroj th.l, .kasa-obracun table.zbroj td.l { text-align: left; }
.kasa-obracun table.zbroj td {
  padding: 7px 12px;
  border-bottom: 1px solid #eef1f4;
  text-align: right;
  font-variant-numeric: tabular-nums;
  font-size: 14px;
}
.kasa-obracun table.zbroj .jako { font-weight: 700; }
.kasa-obracun table.zbroj tr.zbrojni td {
  border-top: 2px solid #1976d2;
  border-bottom: 0;
  font-weight: 700;
  background: #f7fafd;
}

.kasa-obracun .greska-traka {
  background: #fdecea;
  border-left: 4px solid #c62828;
  color: #c62828;
  padding: 12px 16px;
  margin-bottom: 12px;
}
.kasa-obracun .prazno { padding: 48px 16px; text-align: center; color: #90a4ae; }
.kasa-obracun .uz { color: #607d8b; font-size: 12px; }
</style>
